import { restApi } from '../../../api';
import {
  GetKitCombination,
  GetKitCombinationCount,
  GetKitCombinationsPageParams,
  KitDetails,
} from './kitDetails.types';

const rootPath = '/kit-details';

export const getKitDetails = (kitId: string) => restApi.get<KitDetails>(`${rootPath}/${kitId}`);

export const getKitCombinationsPage = ({ kitId, filters }: GetKitCombinationsPageParams) =>
  restApi.get<GetKitCombination[]>(`${rootPath}/${kitId}/combinations/page`, { ...filters });

export const getKitCombinationsCount = ({ kitId, filters }: GetKitCombinationsPageParams) =>
  restApi.get<GetKitCombinationCount[]>(`${rootPath}/${kitId}/combinations/count`, {
    ...filters,
  });

export const onlineKitDetailsRepository = () => ({
  getKitDetails,
  getKitCombinationsPage,
  getKitCombinationsCount,
});
